import RenderName from './render-name';

export default RenderName;
